import axios from 'axios';

export const fetchProfile = (accessToken) => {
  return axios.get(`${process.env.REACT_APP_API_URL}/profile`, {
    headers: {'Authorization': `Basic ${accessToken}`}
  });
};

export const forgotPassword = (email) => {
  return axios.get(`${process.env.REACT_APP_API_URL}/api/clients/forgot-password`, {
    params: {
      email
    }
  });
};

export const resetPassword = (data) => {
  return axios.post(`${process.env.REACT_APP_API_URL}/api/clients/forgot-password`, {
    token: data.token,
    password: data.password,
    password_confirmation: data.passwordConfirmation
  });
};


// WEBPACK FOOTER //
// ./src/utils/api.js